import { render, staticRenderFns } from "./PostAblitityQueryPage.vue?vue&type=template&id=8fa8a7c4"
import script from "./PostAblitityQueryPage.vue?vue&type=script&lang=js"
export * from "./PostAblitityQueryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports